export default {
  '/accountsettings': 0,
  '/accountsettings/': 0,
  '/contacts': 1,
  '/contacts/': 1,
  '/contacts/new': 1,
  '/contacts/new/': 1,
  '/contactgroups': 2,
  '/contactgroups/': 2,
  '/forms': 3,
  '/forms/': 3,
  '/forms/new': 3,
  '/forms/new/': 3,
  '/tasks': 4,
  '/tasks/': 4,
  '/tasks/new': 4,
  '/tasks/new/': 4,
}
